import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import _ from "lodash";
// QUINLAN
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import UserModule from "@/store/modules/user.module";
import { UserModel } from "@/store/models/users/addUser";
import Loader from "../../../components/widgets/loader.vue";
import { interpret } from "xstate/lib/interpreter";
import addUserMachine from "./machines/addUserMachine";
/**
 * Add User Components
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let AddUser = /** @class */ (() => {
    let AddUser = class AddUser extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.pageIsLoading = true;
            this.ctaButtons = [{ routeName: "Users" }];
            this.title = "Add New User";
            this.selectedRole = null;
            this.selectedOrganization = "";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Users",
                    to: "/users",
                },
                {
                    text: "Add User",
                    active: true,
                },
            ];
            this.user = new UserModel();
            this.machine = addUserMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        saveUser() {
            this.validate("newUserObserver").then((response) => {
                if (response) {
                    this.pageIsLoading = true;
                    this.user.roles = [this.selectedRole];
                    this.machineService.send({ type: "SAVE_USER", user: this.user });
                }
            });
        }
        send(event) {
            this.machineService.send(event);
        }
        cancel() {
            this.$router.push({ name: "Users" });
        }
        get roles() {
            return UserModule.roles;
        }
        get organizations() {
            return UserModule.organizations;
        }
        get sortedRoles() {
            return _.sortBy(this.roles, (o) => o.value);
        }
        //Lifecycle
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("loadedDetails")) {
                    this.pageIsLoading = false;
                }
                if (this.state.matches("savingUser") && previousState.matches("savingUser")) {
                    this.$router.push({ name: "Users" });
                }
                if (this.state.matches("loadedDetails") && previousState.matches("savingUser")) {
                    this.pageIsLoading = false;
                }
            });
        }
    };
    AddUser = __decorate([
        Component({
            name: "AddUser",
            components: {
                Layout,
                PageHeader,
                Loader,
            },
        })
    ], AddUser);
    return AddUser;
})();
export default AddUser;
